import React from 'react';
import { EditCredentialsState } from './editCredentialsState/EditCredentialsState';
import WithAdditionalValidationState from 'components/WithAdditionalValidation/WithAdditionalValidationState';
import { EditForm } from './components/EditForm/EditForm';
import { ModalWindows } from './components/ModalWindows';
// import style from './index.module.scss';

export const EditCredentialsPage: React.FC = () => {
	return (
		<EditCredentialsState>
			<WithAdditionalValidationState>
				<EditForm />
			</WithAdditionalValidationState>
			<ModalWindows />
		</EditCredentialsState>
	);
};
